import PartnerModule from '../moduls/PartnerModul';
import { APP_CONSTANTS } from '../constants/constants';
import store from '../../state-management/store';
import {cntrlGetPartnerColors} from '../../state-management/actions/partnerActions';

export const SkinningHelperInit = async () => {
  const partnerId = PartnerModule.getConfigItem(APP_CONSTANTS.PARTNER_ID);
  await store.dispatch(cntrlGetPartnerColors(partnerId));
};
